import styled from "styled-components";

export const CalendarContainer = styled.div`
    width: min(92%, 1280px);
    margin: 60px auto 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;

    > div {
        background: white;
        padding: 24px 22px;
        border-radius: var(--radius-xl);
        border: 1px solid var(--color-border);
        box-shadow: var(--shadow-sm);
        transition: var(--transition);
    }

    > div:hover {
        box-shadow: var(--shadow-md);
        border-color: var(--color-primary-light);
    }

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        gap: 24px;
        margin-top: 40px;
    }
`;

export const CalendarTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 4px;
`;

export const CalendarWrapper = styled.div`
    width: 100%;
    border-collapse: collapse;
`;

export const CalendarTh = styled.th`
    padding: 8px 4px;
    text-align: center;
    color: var(--color-text-muted);
    font-weight: 700;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const CalendarThBack = styled.th`
    padding: 8px 4px;
    text-align: center;
    background: var(--color-primary);
    color: white;
    font-weight: 700;
    border-radius: 50%;
    width: 34px;
    height: 34px;
`;

export const CalendarTd = styled.td`
    padding: 8px 4px;
    text-align: center;
    color: var(--color-text);
    font-size: 14px;
    font-weight: 500;
`;

export const MonthHead = styled.p`
    font-size: 20px;
    font-weight: 800;
    color: var(--color-primary);
    margin: 0 0 14px 6px;
    letter-spacing: -0.3px;
`;
